import React, { Component } from "react";

import { connect } from "react-redux";
import { actions } from "./redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import securityservice from "../../services/security/security";
import { Button, Grid, RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import styles from "../Login/styles.scss";
import CSSModules from "react-css-modules";

let userexists = false;

@CSSModules(styles, { allowMultiple: true })
class SignUp extends Component {
	renderRadio(props) {
		let {
			input,
			label,
			value,
			securetext,
			type
		} = props;

		return (
			<RadioGroup
				aria-label="gender"
				name="gender1"
				value={input.value}
				row={true}
				style={{ justifyContent: "center" }}
				onChange={e => {
					input.onChange(e.target.value);
				}}>
				<FormControlLabel
					className="white-cascade"
					value="male"
					control={<Radio style={{ color: "#fff" }} color="default" />}
					label="Male"
				/>
				<FormControlLabel
					className="white-cascade"
					value="female"
					control={<Radio style={{ color: "#fff" }} color="default" />}
					label="Female"
				/>
			</RadioGroup>
		);
	}

	renderInput(props) {
		let {
			input,
			label,
			placeholder,
			type,
			meta: { touched, error },
			...other
		} = props;
		return (
			<div>
				<div style={{ ...styles.inputGrp, ...other.containerStyle }}>
					<input
						style={{ ...styles.inputStyle, ...styles.rawInput, ...other.inputStyle }}
						placeholder={label}
						{...input}
						disableUnderline
						type={other.secure ? "password" : "text"}
					/>
				</div>
				{touched && error && <p style={styles.formErrorp1}>{error}</p>}
			</div>
		);
	}

	createUser(data) {
		this.props.create(data);
	}

	render() {
		const { handleSubmit } = this.props;
		const styles = this.props.styles;
		return (
			<div>
				<div>
					<Grid container>
						<Grid xs={12} sm={6} item>
							<Field
								name="firstname"
								containerStyle={{ marginRight: window.innerWidth > 600 ? 5 : 0 }}
								component={this.renderInput}
								styles={styles}
								inputStyle={{ width: "0px" }}
								label="First Name"
							/>
						</Grid>
						<Grid xs={12} sm={6} item>
							<Field
								name="lastName"
								containerStyle={{ marginLeft: window.innerWidth > 600 ? 5 : 0 }}
								styles={styles}
								component={this.renderInput}
								inputStyle={{ width: "0px" }}
								label="Last Name"
							/>
						</Grid>
					</Grid>
				</div>
				<div style={{ flexDirection: "row" }}>
					<div style={{ flex: 1 }}>
						<Field
							name="username"
							styles={styles}
							component={this.renderInput}
							onblur={val => {
								securityservice.checkUserName(val).then(function(d) {
									userexists = d;
								});
							}}
							label="Username"
						/>
					</div>
				</div>
				<div style={{ flexDirection: "row" }}>
					<div style={{ flex: 1 }}>
						<Field name="email" styles={styles} component={this.renderInput} label="Email" />
					</div>
				</div>

				<div style={{ flexDirection: "row" }}>
					<div style={{ flex: 1 }}>
						<Field name="password" styles={styles} component={this.renderInput} secure label="Password" />
					</div>
				</div>
				<div style={{ flexDirection: "row" }}>
					<div style={{ flex: 1 }}>
						<Field
							name="passwordreenter"
							styles={styles}
							component={this.renderInput}
							secure
							label="Confirm Password"
						/>
					</div>
				</div>
				<div style={{ flexDirection: "row" }}>
					<div style={{ flex: 1 }}>
						<Field name="gender" styles={styles} component={this.renderRadio} />
					</div>
				</div>
				<div style={{ flexDirection: "row" }}>
					{this.props.hasError && (
						<p style={{ ...styles.formErrorText1, ...{ textAlign: "center" } }}>
							{this.props.errors.slice(-1)}
						</p>
					)}
				</div>
				<div style={{ display: "flex", justifyContent: "center", flexDirection: "row" }}>
					<Button
						onClick={handleSubmit(data => this.createUser(data))}
						style={{ border: "none", width: 120, color: "#999",  height: 50, fontSize: 17, fontFamily: "Raleway" }}
						className="white-button">
						Create
					</Button>
				</div>
			</div>
		);
	}
}

const SignUpForm = reduxForm({
	form: "signup",
	validate: v => {
		const errors = {};

		if (!v.firstname) {
			errors.firstname = "Required";
			//alpha chars plus'-'. cannot start or end with '-'
		} else if (/^\-|\-$|[^a-zA-Z\-]/i.test(v.firstname)) {
			errors.firstname = "Invalid Characters";
		}

		if (!v.lastName) {
			errors.lastName = "Required";
			//alpha chars plus'-'. cannot start or end with '-'
		} else if (/^\-|\-$|[^a-zA-Z\-]/i.test(v.lastName)) {
			errors.lastName = "Invalid Characters";
		}

		if (!v.username) {
			errors.username = "Required";
		} else if (v.username.length < 5) {
			errors.username = "Username Too Short";
			//alpha numeric underscore
		} else if (/[^a-zA-Z\d\_]/i.test(v.username)) {
			errors.username = "Invalid Username";
		} else if (userexists) {
			errors.username = "Username Already Exists";
		}

		if (!v.email) {
			errors.email = "Required";
		} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{1,}$/i.test(v.email)) {
			errors.email = "Invalid Email";
		}

		// if (!v.emailreenter) {
		//   errors.emailreenter = "Required"
		// } else if (v.email != v.emailreenter) {
		//   errors.emailreenter = "Emails do not match"
		// }

		// //numbers plus'()-' only
		// if (v.phone && /[^\d()\-]/.test(v.phone)) {
		//   errors.phone = "Invalid Phone Number"
		// }

		if (!v.password) {
			errors.password = "Required";
		} else if (v.password.length < 6) {
			errors.password = "Password too short";
			//at least 1 upper and lower, one non alphanum char and one number
		} else if (!/(?=.*[A-Z])(?=.*[a-z])(?=.*[\d])(?=.*[\W+])/.test(v.password)) {
			errors.password = `Passwords must have at least one non letter or digit character, at least one digit ('0'-'9') and at least one uppercase and one lowercase letter.`;
		}

		if (!v.passwordreenter) {
			errors.passwordreenter = "Required";
		} else if (v.password !== v.passwordreenter) {
			errors.passwordreenter = "Passwords do not match";
		}

		if (!v.gender) {
			errors.gender = "Required";
		}

		return errors;
	}
})(SignUp);

const formSelector = formValueSelector("signup");

const bindAction = dispatch => {
	return {
		create: user => dispatch(actions.create(user))
	};
};

const mapStateToProps = state => ({
	username: formSelector(state, "username"),
	password: formSelector(state, "password"),
	gender: formSelector(state, "gender"),

	isBusy: state.signup.isBusy,
	errors: state.signup.errors,
	hasError: state.signup.hasError
});

export default connect(mapStateToProps, bindAction)(SignUpForm);



// WEBPACK FOOTER //
// ./src/ui/SignUp/SignUp.js